import React, { useEffect, useState, useMemo, useCallback, useRef } from "react";
import {
  ApplyThemeStyles,
  SectionContentMasterData,
  SectionMasterData,
  ThemeData,
} from "../../Utility/Utility";
import { useLocation } from "react-router-dom";
import ScrollToTop from "../../Utility/ScrollToTop/ScrollToTop";
import { useDispatch } from "react-redux";
import { onLandingHome } from "../../Store/Slices/homePageLandingSlice";
import CustomBackHeader from "../../Utility/CustomBackHeader/CustomBackHeader";

const ContactUs = () => {
  const login = sessionStorage.getItem("login");
  const [contentData, setContentData] = useState(null);
  const { sectionMasterData } = SectionMasterData(login);
  const { sctionContentdata } = SectionContentMasterData();

  const themeData = ThemeData();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    ApplyThemeStyles(themeData);
  }, [themeData]);

  useEffect(() => {
    sessionStorage.removeItem("toTop");
  }, [location.pathname]);

  // Memoize sectionFilter to prevent recalculation
  const sectionFilter = useMemo(() => {
    return sectionMasterData?.find(
      (findData) => findData?.sectionType === "Footer"
    );
  }, [sectionMasterData]);

  // Memoize sectionContent to prevent recalculation
  const sectionContent = useMemo(() => {
    return sctionContentdata?.filter(
      (findData) => findData?.sectionMasterId === sectionFilter?.id
    );
  }, [sctionContentdata, sectionFilter?.id]);

  // Memoize content search function
  const findMatchingContent = useCallback((currentPath, sectionContent) => {
    return sectionContent?.find((content) => {
      const sectionName = content?.contentSourceType?.toLowerCase() || '';
      const pathName = currentPath.replace('/', '').toLowerCase().split('-');
      return sectionName.includes(pathName[0]);
    });
  }, []);

  useEffect(() => {
    if (location.pathname) {
      setContentData(findMatchingContent(location.pathname, sectionContent));
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 0);
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  useEffect(() => {
    dispatch(onLandingHome());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <ScrollToTop />
      <CustomBackHeader title={contentData?.contentSourceType} />
      <div className="contact-container">
        <div className="px-4 py-4">
          <span
            dangerouslySetInnerHTML={{
              __html: contentData?.text,
            }}
          />
        </div>
      </div>
    </>
  );
};

export default ContactUs;
